import React from 'react';

const ICON_VERSION = '2';

export function CardIcon({ className, ...props }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM14 18H3V6H19V13H21V6C21 4.89 20.11 4 19 4H3C2.46957 4 1.96086 4.21071 1.58579 4.58579C1.21071 4.96086 1 5.46957 1 6V18C1 18.5304 1.21071 19.0391 1.58579 19.4142C1.96086 19.7893 2.46957 20 3 20H14V18Z"
        fill="white"
      />
    </svg>
  );
}

export function PaymentIconImg({ src, alt, className }) {
  const url = src && typeof src === 'string' ? `${src}?v=${ICON_VERSION}` : src;
  return <img src={url} alt={alt} className={className} decoding="async" />;
}
